import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

export const ERROR_PLACE = {
    topRight: "top-right",
    bottomRight: "bottom-right",
    bottomLeft: "bottom-left",
    center: "center",
    topLeft: "top-left",
    static: "static",
    none: "none",
};

const InputError = ({ message, mode }) => {
    return (
        mode !== ERROR_PLACE.none && (
            <span className={cn(styles["forms__error"], styles[`forms__error--${mode}`])}>
                <span className={styles["error__icon"]} />
                {message}
            </span>
        )
    );
};

export default InputError;
